import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const CardiometabolicInflammationDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const adipoq = getGenePalette(geneColors.ADIPOQ);
  const nfe2l2 = getGenePalette(geneColors.NFE2L2);
  const ucp2 = getGenePalette(geneColors.UCP2);
  const sod2 = getGenePalette(geneColors.SOD2);
  const cat = getGenePalette(geneColors.CAT);
  const tnf = getGenePalette(geneColors.TNF);
  const il6 = getGenePalette(geneColors.IL6);
  const irs1 = getGenePalette(geneColors.IRS1);
  const slc2a2 = getGenePalette(geneColors.SLC2A2);
  const crp = getGenePalette(geneColors.CRP);
  const gpx1 = getGenePalette(geneColors.GPX1);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18293_231788)">
        <rect width={1024} height={1370} transform="translate(0 170)" fill="white" />
        <g id="cardiometobolic-Inflammation-diagram">
          <rect width={1024} height={1370} transform="translate(0 170)" fill="white" />
          <g id="lines">
            <path
              id="Vector"
              d="M512.742 438.7L512.742 438L511.342 438L511.342 438.7L512.042 438.7L512.742 438.7ZM512.042 466L516.083 459L508 459L512.042 466ZM512.042 438.7L511.342 438.7L511.342 459.7L512.042 459.7L512.742 459.7L512.742 438.7L512.042 438.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_2">
            <path
              id="Vector_2"
              d="M511.742 569.7L511.742 569L510.342 569L510.342 569.7L511.042 569.7L511.742 569.7ZM511.042 597L515.083 590L507 590L511.042 597ZM511.042 569.7L510.342 569.7L510.342 590.7L511.042 590.7L511.742 590.7L511.742 569.7L511.042 569.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="report-label">
            <g id="Report titles">
              <rect width={175} height={28} transform="translate(423 468)" fill="white" />
              <text
                fontFamily="Gilroy W05 Medium"
                id="25-Hydroxy Vitamin D"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={423.367} y={487.448}>
                  Inflamed adipose tissue
                </tspan>
              </text>
            </g>
            <g id="lines_3">
              <path
                id="Vector_3"
                d="M511.158 496.7L511.158 496L509.758 496L509.758 496.7L510.458 496.7L511.158 496.7ZM510.458 526L514.5 519L506.417 519L510.458 526ZM510.458 496.7L509.758 496.7L509.758 519.7L510.458 519.7L511.158 519.7L511.158 496.7L510.458 496.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_2">
            <g id="Report titles_2">
              <rect width={90} height={46} transform="translate(466 596)" fill="white" />
              <text
                fontFamily="Gilroy W05 Medium"
                id="25-Hydroxy Vitamin D_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={466.445} y={615.448}>
                  Adiponectin
                </tspan>
              </text>
              <text
                fontFamily="Gilroy W05 Regular"
                id="Sub Label"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={480.355} y={634.08}>
                  (Low levels)
                </tspan>
              </text>
            </g>
            <g id="lines_4">
              <path
                id="Vector_4"
                d="M511.658 638.7L511.658 638L510.258 638L510.258 638.7L510.958 638.7L511.658 638.7ZM510.958 667L515 660L506.917 660L510.958 667ZM510.958 638.7L510.258 638.7L510.258 660.7L510.958 660.7L511.658 660.7L511.658 638.7L510.958 638.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_3">
            <g id="Report titles_3">
              <rect width={86} height={46} transform="translate(593 1089)" fill="white" />
              <text
                fontFamily="Gilroy W05 Medium"
                id="25-Hydroxy Vitamin D_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={617.07} y={1108.45}>
                  TNFa
                </tspan>
              </text>
              <text
                fontFamily="Gilroy W05 Regular"
                id="Sub Label_2"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={593.057} y={1127.08}>
                  (early response)
                </tspan>
              </text>
            </g>
            <g id="lines_5">
              <path
                id="Vector_5"
                d="M636.658 1131.7L636.658 1131L635.258 1131L635.258 1131.7L635.958 1131.7L636.658 1131.7ZM635.958 1151L640 1144L631.917 1144L635.958 1151ZM635.958 1131.7L635.258 1131.7L635.258 1144.7L635.958 1144.7L636.658 1144.7L636.658 1131.7L635.958 1131.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_4">
            <g id="Report titles_4">
              <rect width={21} height={28} transform="translate(624 1217)" fill="white" />
              <text
                fontFamily="Gilroy W05 Medium"
                id="25-Hydroxy Vitamin D_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={624.406} y={1236.45}>
                  IL6
                </tspan>
              </text>
            </g>
            <g id="lines_6">
              <path
                id="Vector_6"
                d="M635.158 1245.7L635.158 1245L633.758 1245L633.758 1245.7L634.458 1245.7L635.158 1245.7ZM634.458 1264L638.5 1257L630.417 1257L634.458 1264ZM634.458 1245.7L633.758 1245.7L633.758 1257.7L634.458 1257.7L635.158 1257.7L635.158 1245.7L634.458 1245.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_5">
            <g id="Report titles_5">
              <rect width={84} height={36} transform="translate(122 1305)" fill="white" />
              <text
                fontFamily="Gilroy W05 Medium"
                id="25-Hydroxy Vitamin D_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={122.088} y={1319.09}>
                  Insulin receptor{" "}
                </tspan>
                <tspan x={137.844} y={1335.09}>
                  signalling
                </tspan>
              </text>
            </g>
            <g id="lines_7">
              <path
                id="Vector_7"
                d="M164.658 1341.7L164.658 1341L163.258 1341L163.258 1341.7L163.958 1341.7L164.658 1341.7ZM163.958 1366L168 1359L159.917 1359L163.958 1366ZM163.958 1341.7L163.258 1341.7L163.258 1359.7L163.958 1359.7L164.658 1359.7L164.658 1341.7L163.958 1341.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_6">
            <g id="Report titles_6">
              <rect width={56} height={28} transform="translate(607 1339)" fill="white" />
              <text
                fontFamily="Gilroy W05 Medium"
                id="25-Hydroxy Vitamin D_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={607.359} y={1358.45}>
                  hs-CRP
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_7">
            <g id="Report titles_7">
              <rect width={202} height={20} transform="translate(66 1476)" fill="white" />
              <text
                fontFamily="Gilroy W05 Medium"
                id="25-Hydroxy Vitamin D_7"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={99.8574} y={1490.09}>
                  GLUT4 & glucose uptake
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_8">
            <g id="Report titles_8">
              <rect width={182} height={61} transform="translate(421 669)" fill="white" />
              <text
                fontFamily="Gilroy W05 Medium"
                id="25-Hydroxy Vitamin D_8"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={496.312} y={688.448}>
                  ROS
                </tspan>
              </text>
              <text
                fontFamily="Gilroy W05 Regular"
                id="Sub Label_3"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={428.668} y={707.08}>
                  in mitochondria (major) & non-
                </tspan>
                <tspan x={432.283} y={725.08}>
                  mitochondrial compartments
                </tspan>
              </text>
            </g>
            <g id="lines_8">
              <path
                id="Vector_8"
                d="M512.658 730.7L512.658 730L511.258 730L511.258 730.7L511.958 730.7L512.658 730.7ZM511.958 759L516 752L507.917 752L511.958 759ZM511.958 730.7L511.258 730.7L511.258 752.7L511.958 752.7L512.658 752.7L512.658 730.7L511.958 730.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="lines_9">
            <path
              id="Vector_9"
              d="M748.742 454.7L748.742 454L747.342 454L747.342 454.7L748.042 454.7L748.742 454.7ZM748.041 664L752.083 657L744 657L748.041 664ZM748.042 454.7L747.342 454.7L747.341 657.7L748.041 657.7L748.741 657.7L748.742 454.7L748.042 454.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_10">
            <path
              id="Vector_10"
              d="M685.742 839.7L685.742 839L684.342 839L684.342 839.7L685.042 839.7L685.742 839.7ZM685.042 869L689.083 862L681 862L685.042 869ZM685.042 839.7L684.342 839.7L684.342 862.7L685.042 862.7L685.742 862.7L685.742 839.7L685.042 839.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_11">
            <path
              id="Vector_11"
              d="M635.742 1000.7L635.742 1000L634.342 1000L634.342 1000.7L635.042 1000.7L635.742 1000.7ZM635.042 1030L639.083 1023L631 1023L635.042 1030ZM635.042 1000.7L634.342 1000.7L634.342 1023.7L635.042 1023.7L635.742 1023.7L635.742 1000.7L635.042 1000.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_12">
            <path
              id="Vector_12"
              d="M366.742 1000.7L366.742 1000L365.342 1000L365.342 1000.7L366.042 1000.7L366.742 1000.7ZM366.042 1066L370.083 1059L362 1059L366.042 1066ZM366.042 1000.7L365.342 1000.7L365.342 1059.7L366.042 1059.7L366.742 1059.7L366.742 1000.7L366.042 1000.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_13">
            <path
              id="Vector_13"
              d="M568.742 839.7L568.742 839L567.342 839L567.342 839.7L568.042 839.7L568.742 839.7ZM568.042 869L572.083 862L564 862L568.042 869ZM568.042 839.7L567.342 839.7L567.342 862.7L568.042 862.7L568.742 862.7L568.742 839.7L568.042 839.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_14">
            <path
              id="Vector_14"
              d="M635.742 1196.7L635.742 1196L634.342 1196L634.342 1196.7L635.042 1196.7L635.742 1196.7ZM635.042 1217L639.083 1210L631 1210L635.042 1217ZM635.042 1196.7L634.342 1196.7L634.342 1210.7L635.042 1210.7L635.742 1210.7L635.742 1196.7L635.042 1196.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_15">
            <path
              id="Vector_15"
              d="M635.658 1310.7L635.658 1310L634.258 1310L634.258 1310.7L634.958 1310.7L635.658 1310.7ZM634.958 1340L639 1333L630.917 1333L634.958 1340ZM634.958 1310.7L634.258 1310.7L634.258 1333.7L634.958 1333.7L635.658 1333.7L635.658 1310.7L634.958 1310.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_16">
            <path
              id="Vector_16"
              d="M162.742 1406.7L162.742 1406L161.342 1406L161.342 1406.7L162.042 1406.7L162.742 1406.7ZM162.042 1436L166.083 1429L158 1429L162.042 1436ZM162.042 1406.7L161.342 1406.7L161.342 1429.7L162.042 1429.7L162.742 1429.7L162.742 1406.7L162.042 1406.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_17">
            <path
              id="Vector_17"
              d="M433.8 1230.74L434.5 1230.74L434.5 1229.34L433.8 1229.34L433.8 1230.04L433.8 1230.74ZM429.5 1230.04L436.5 1234.08L436.5 1226L429.5 1230.04Z"
              fill="#E44C4B"
            />
          </g>
          <g id="lines_18">
            <path
              id="Vector_18"
              d="M434.8 1115.74L435.5 1115.74L435.5 1114.34L434.8 1114.34L434.8 1115.04L434.8 1115.74ZM430.5 1115.04L437.5 1119.08L437.5 1111L430.5 1115.04Z"
              fill="#E44C4B"
            />
          </g>
          <g id="lines_19">
            <path
              id="Vector_19"
              d="M635.658 1074.7L635.658 1074L634.258 1074L634.258 1074.7L634.958 1074.7L635.658 1074.7ZM634.958 1092L639 1085L630.917 1085L634.958 1092ZM634.958 1074.7L634.258 1074.7L634.258 1085.7L634.958 1085.7L635.658 1085.7L635.658 1074.7L634.958 1074.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_20">
            <path
              id="Vector_20"
              d="M454.741 839.7L454.741 839L453.341 839L453.341 839.7L454.041 839.7L454.741 839.7ZM454.041 869L458.082 862L449.999 862L454.041 869ZM454.041 839.7L453.341 839.7L453.341 862.7L454.041 862.7L454.741 862.7L454.741 839.7L454.041 839.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_21">
            <path
              id="Vector_21"
              d="M506.7 801.7L506.7 838.3"
              stroke="#1A1A1A"
              strokeWidth={1.4}
              strokeLinecap="square"
            />
          </g>
          <g id="lines_22">
            <path
              id="Vector_22"
              d="M327.742 839.7L327.742 839L326.342 839L326.342 839.7L327.042 839.7L327.742 839.7ZM327.042 869L331.083 862L323 862L327.042 869ZM327.042 839.7L326.342 839.7L326.342 862.7L327.042 862.7L327.742 862.7L327.742 839.7L327.042 839.7Z"
              fill="#1A1A1A"
            />
          </g>
          <path
            id="Vector 435"
            d="M838 1044V1044.7H838.7V1044H838ZM681 1044L688 1048.04V1039.96L681 1044ZM838 456H837.3V1044H838H838.7V456H838ZM838 1044V1043.3H687.3V1044V1044.7H838V1044Z"
            fill="black"
          />
          <path
            id="Vector 433"
            d="M746.5 784.5V785.2H747.2V784.5H746.5ZM567 784.5L574 788.541V780.459L567 784.5ZM746.5 699H745.8V784.5H746.5H747.2V699H746.5ZM746.5 784.5V783.8H573.3V784.5V785.2H746.5V784.5Z"
            fill="black"
          />
          <path
            id="Vector 434"
            d="M184 784.5V785.2H183.3V784.5H184ZM454 784.5L447 788.541V780.459L454 784.5ZM184 702H184.7V784.5H184H183.3V702H184ZM184 784.5V783.8H447.7V784.5V785.2H184V784.5Z"
            fill="black"
          />
          <g id="lines_23">
            <path
              id="Vector_23"
              d="M723.342 687.3L723.342 688L724.742 688L724.742 687.3L724.042 687.3L723.342 687.3ZM724.042 674L720 681L728.083 681L724.042 674ZM724.042 687.3L724.742 687.3L724.742 680.3L724.042 680.3L723.342 680.3L723.342 687.3L724.042 687.3Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_24">
            <path
              id="Vector_24"
              d="M894.742 744.7L894.742 744L893.342 744L893.342 744.7L894.042 744.7L894.742 744.7ZM894.042 758L898.083 751L890 751L894.042 758ZM894.042 744.7L893.342 744.7L893.342 751.7L894.042 751.7L894.742 751.7L894.742 744.7L894.042 744.7Z"
              fill="#5220DD"
            />
          </g>
          <g id="lines_25">
            <path
              id="Vector_25"
              d="M902.342 1052.3L902.342 1053L903.742 1053L903.742 1052.3L903.042 1052.3L902.342 1052.3ZM903.042 1039L899 1046L907.083 1046L903.042 1039ZM903.042 1052.3L903.742 1052.3L903.742 1045.3L903.042 1045.3L902.342 1045.3L902.342 1052.3L903.042 1052.3Z"
              fill="#5220DD"
            />
          </g>
          <g id="lines_26">
            <path
              id="Vector_26"
              d="M902.342 1167.3L902.342 1168L903.742 1168L903.742 1167.3L903.042 1167.3L902.342 1167.3ZM903.042 1154L899 1161L907.083 1161L903.042 1154ZM903.042 1167.3L903.742 1167.3L903.742 1160.3L903.042 1160.3L902.342 1160.3L902.342 1167.3L903.042 1167.3Z"
              fill="#5220DD"
            />
          </g>
          <g id="lines_27">
            <path
              id="Vector_27"
              d="M161.342 691.3L161.342 692L162.742 692L162.742 691.3L162.042 691.3L161.342 691.3ZM162.042 678L158 685L166.083 685L162.042 678ZM162.042 691.3L162.742 691.3L162.742 684.3L162.042 684.3L161.342 684.3L161.342 691.3L162.042 691.3Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_28">
            <path
              id="Vector_28"
              d="M90.7415 1478.7L90.7415 1478L89.3415 1478L89.3415 1478.7L90.0415 1478.7L90.7415 1478.7ZM90.0415 1492L94.083 1485L86.0001 1485L90.0415 1492ZM90.0415 1478.7L89.3415 1478.7L89.3415 1485.7L90.0415 1485.7L90.7415 1485.7L90.7415 1478.7L90.0415 1478.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_29">
            <path
              id="Vector_29"
              d="M342.742 1073.7L342.742 1073L341.342 1073L341.342 1073.7L342.042 1073.7L342.742 1073.7ZM342.042 1087L346.083 1080L338 1080L342.042 1087ZM342.042 1073.7L341.342 1073.7L341.342 1080.7L342.042 1080.7L342.742 1080.7L342.742 1073.7L342.042 1073.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_30">
            <path
              id="Vector_30"
              d="M487.342 687.3L487.342 688L488.742 688L488.742 687.3L488.042 687.3L487.342 687.3ZM488.042 674L484 681L492.083 681L488.042 674ZM488.042 687.3L488.742 687.3L488.742 680.3L488.042 680.3L487.342 680.3L487.342 687.3L488.042 687.3Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_31">
            <path
              id="Vector_31"
              d="M184.742 454.7L184.742 454L183.342 454L183.342 454.7L184.042 454.7L184.742 454.7ZM184.041 667L188.083 660L180 660L184.041 667ZM184.042 454.7L183.342 454.7L183.341 660.7L184.041 660.7L184.741 660.7L184.742 454.7L184.042 454.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Frame 465">
            <path
              d="M51 210.7H339C345.241 210.7 350.3 215.759 350.3 222V442C350.3 448.241 345.241 453.3 339 453.3H51C44.7592 453.3 39.7002 448.241 39.7002 442V222C39.7002 215.759 44.7592 210.7 51 210.7Z"
              stroke="#1A1A1A"
              strokeWidth={1.4}
            />
            <g id="Rich Text Block">
              <text
                fontFamily="Gilroy W05 Bold"
                id="H2 Header"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={55} y={245.464}>
                  Oxidative stress triggers
                </tspan>
              </text>
              <text
                fontFamily="Gilroy W05 Medium"
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={73} y={271.086}>
                  Cigarette smoking /vaping{" "}
                </tspan>
                <tspan x={73} y={289.086}>
                  UV radiation /sunburn{" "}
                </tspan>
                <tspan x={73} y={307.086}>
                  Environmental toxins (pesticides, heavy metals,{" "}
                </tspan>
                <tspan x={73} y={325.086}>
                  air pollution){" "}
                </tspan>
                <tspan x={73} y={343.086}>
                  Alcohol (chronic/excessive){" "}
                </tspan>
                <tspan x={73} y={361.086}>
                  Medication induced ROS (chemotherapy,{" "}
                </tspan>
                <tspan x={73} y={379.086}>
                  antibiotics){" "}
                </tspan>
                <tspan x={73} y={397.086}>
                  Exercise (acute ROS){" "}
                </tspan>
                <tspan x={73} y={415.086}>
                  Hyperglycaemia{" "}
                </tspan>
                <tspan x={73} y={433.086}>
                  Mitochondrial dysfunction
                </tspan>
              </text>
            </g>
          </g>
          <g id="Frame 467">
            <path
              d="M384 210.7H637C643.241 210.7 648.3 215.759 648.3 222V426C648.3 432.241 643.241 437.3 637 437.3H384C377.759 437.3 372.7 432.241 372.7 426V222C372.7 215.759 377.759 210.7 384 210.7Z"
              stroke="#1A1A1A"
              strokeWidth={1.4}
            />
            <g id="Rich Text Block_2">
              <text
                fontFamily="Gilroy W05 Bold"
                id="H2 Header_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={388} y={245.464}>
                  Metabolic/Adipose triggers
                </tspan>
              </text>
              <text
                fontFamily="Gilroy W05 Medium"
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={406} y={271.086}>
                  Chronic over nutrition{" "}
                </tspan>
                <tspan x={406} y={289.086}>
                  Caloric excess{" "}
                </tspan>
                <tspan x={406} y={307.086}>
                  Obesity{" "}
                </tspan>
                <tspan x={406} y={325.086}>
                  High intake of processed foods{" "}
                </tspan>
                <tspan x={406} y={343.086}>
                  High sugar diet{" "}
                </tspan>
                <tspan x={406} y={361.086}>
                  High trans fat diet{" "}
                </tspan>
                <tspan x={406} y={379.086}>
                  Sedentary lifestyle (in context of&#13;obesity){" "}
                </tspan>
                <tspan x={406} y={397.086}>
                  Metabolic syndrome{" "}
                </tspan>
                <tspan x={406} y={415.086}>
                  Insulin resistance
                </tspan>
              </text>
            </g>
          </g>
          <g id="Frame 468">
            <path
              d="M685 210.7H959C965.241 210.7 970.3 215.759 970.3 222V442C970.3 448.241 965.241 453.3 959 453.3H685C678.759 453.3 673.7 448.241 673.7 442V222C673.7 215.759 678.759 210.7 685 210.7Z"
              stroke="#1A1A1A"
              strokeWidth={1.4}
            />
            <g id="Rich Text Block_3">
              <text
                fontFamily="Gilroy W05 Bold"
                id="H2 Header_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={689} y={245.464}>
                  Inflammation signalling triggers
                </tspan>
              </text>
              <text
                fontFamily="Gilroy W05 Medium"
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={707} y={271.086}>
                  Chronic infections (viral, bacterial,&#13;parasitic){" "}
                </tspan>
                <tspan x={707} y={289.086}>
                  Chronic stress /persistent high cortisol{" "}
                </tspan>
                <tspan x={707} y={307.086}>
                  Psychological stress /depression /&#13;anxiety{" "}
                </tspan>
                <tspan x={707} y={325.086}>
                  Sleep deprivation /poor sleep quality{" "}
                </tspan>
                <tspan x={707} y={343.086}>
                  Autoimmune conditions{" "}
                </tspan>
                <tspan x={707} y={361.086}>
                  Gut dysbiosis{" "}
                </tspan>
                <tspan x={707} y={379.086}>
                  Chronic pain
                </tspan>
              </text>
            </g>
          </g>
          <g id="Report titles_9">
            <rect width={55} height={20} transform="translate(519 498)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_9"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={519.307} y={512.086}>
                Supresses
              </tspan>
            </text>
          </g>
          <g id="Report titles_10">
            <rect width={44} height={20} transform="translate(519 734)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_10"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={519.186} y={748.086}>
                Triggers
              </tspan>
            </text>
          </g>
          <g id="Report titles_11">
            <rect width={44} height={20} transform="translate(196 757.5)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_11"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={196.186} y={771.586}>
                Triggers
              </tspan>
            </text>
          </g>
          <g id="Report titles_12">
            <rect width={58} height={20} transform="translate(359 687)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_12"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={359.147} y={700.405}>
                Oxidises LDL
              </tspan>
            </text>
          </g>
          <g id="Report titles_13">
            <rect width={92} height={68} transform="translate(40 917)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_13"
              fill="#FFC647"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={64.6758} y={930.405}>
                Triggers NF-kB{" "}
              </tspan>
              <tspan x={57.3027} y={946.405}>
                (which activates{" "}
              </tspan>
              <tspan x={40.877} y={962.405}>
                downstream effects{" "}
              </tspan>
              <tspan x={97.5273} y={978.405}>
                TNF, IL6
              </tspan>
            </text>
          </g>
          <g id="Report titles_14">
            <rect width={66} height={20} transform="translate(295 1023)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_14"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={295.258} y={1037.09}>
                If successful
              </tspan>
            </text>
          </g>
          <g id="Report titles_15">
            <rect width={83} height={36} transform="translate(649 989)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_15"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={649.467} y={1003.09}>
                If unsuccessful,{" "}
              </tspan>
              <tspan x={650.668} y={1019.09}>
                triggers NF-kB
              </tspan>
            </text>
          </g>
          <g id="Report titles_16">
            <rect width={81} height={20} transform="translate(752 1048)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_16"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={752.105} y={1062.09}>
                Triggers NF-kB
              </tspan>
            </text>
          </g>
          <g id="Report titles_17">
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_17"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={913.641} y={1051.09}>
                gene{" "}
              </tspan>
              <tspan x={883.957} y={1067.09}>
                expression
              </tspan>
            </text>
          </g>
          <g id="Report titles_18">
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_18"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={913.641} y={1165.09}>
                gene{" "}
              </tspan>
              <tspan x={883.957} y={1181.09}>
                expression
              </tspan>
            </text>
          </g>
          <g id="Report titles_19">
            <rect width={41} height={20} transform="translate(903 742)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_19"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={903.09} y={756.086}>
                Activity
              </tspan>
            </text>
          </g>
          <g id="Report titles_20">
            <rect width={54} height={20} transform="translate(890 664)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_20"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={890.316} y={678.086}>
                Disrupted
              </tspan>
            </text>
          </g>
          <g id="Report titles_21">
            <rect width={65} height={20} transform="translate(646 1241)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_21"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={646.08} y={1255.09}>
                Signals liver
              </tspan>
            </text>
          </g>
          <g id="Report titles_22">
            <rect width={49} height={20} transform="translate(175 1231)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_22"
              fill="#E44C4B"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={175.213} y={1245.09}>
                Damage
              </tspan>
            </text>
          </g>
          <g id="Report titles_23">
            <rect width={49} height={20} transform="translate(175 1117)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_23"
              fill="#E44C4B"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={175.213} y={1131.09}>
                Damage
              </tspan>
            </text>
          </g>
          <g id="Report titles_24">
            <rect width={32} height={28} transform="translate(732.083 669)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_24"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={732.396} y={688.448}>
                ROS
              </tspan>
            </text>
          </g>
          <path
            id="Vector 442"
            d="M949 621L944.959 628H953.041L949 621ZM949 1191V1191.7H949.7V1191H949ZM690 1191L689.482 1191.47L689.69 1191.7H690V1191ZM680 1180L681.718 1187.9L687.699 1182.46L680 1180ZM690 1079L689.505 1079.49L689.71 1079.7H690V1079ZM675 1064L677.092 1071.81L682.807 1066.09L675 1064ZM597 766V765.3H596.882L596.771 765.339L597 766ZM571 775L578.937 776.529L576.293 768.891L571 775ZM607 712L614 716.041V707.959L607 712ZM949 1191V1190.3H690V1191V1191.7H949V1191ZM690 1191L690.518 1190.53L684.756 1184.19L684.238 1184.66L683.72 1185.13L689.482 1191.47L690 1191ZM949 1079H948.3V1191H949H949.7V1079H949ZM949 1079V1078.3H690V1079V1079.7H949V1079ZM690 1079L690.495 1078.51L679.95 1067.96L679.455 1068.45L678.96 1068.95L689.505 1079.49L690 1079ZM949 766H948.3V1079H949H949.7V766H949ZM949 766V765.3H597V766V766.7H949V766ZM597 766L596.771 765.339L576.724 772.278L576.953 772.939L577.182 773.601L597.229 766.661L597 766ZM949 627.3H948.3V712H949H949.7V627.3H949ZM949 712H948.3V766H949H949.7V712H949ZM949 712V711.3H613.3V712V712.7H949V712Z"
            fill="#5220DD"
          />
          <g id="Report titles_25">
            <rect x={905.5} y={562.5} width={87} height={71} fill="white" />
            <rect x={905.5} y={562.5} width={87} height={71} stroke="#5220DD" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_25"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={913.148} y={589.448}>
                Circadian{" "}
              </tspan>
              <tspan x={921.258} y={617.448}>
                Rhythm
              </tspan>
            </text>
          </g>
          <g id="Report titles_26">
            <rect width={105} height={36} transform="translate(631 720)" fill="white" />
            <text
              fontFamily="Gilroy W05 Regular"
              id="25-Hydroxy Vitamin D_26"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={631.386} y={733.4}>
                Positive feedback loop{" "}
              </tspan>
              <tspan x={645.57} y={749.4}>
                (secondary ROS)
              </tspan>
            </text>
          </g>
          <g id="Report titles_27">
            <rect width={87} height={28} transform="translate(460 927)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_27"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={460.234} y={946.448}>
                Try to detox
              </tspan>
            </text>
          </g>
          <g id="Report titles_28">
            <rect width={32} height={28} transform="translate(170 673)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_28"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={170.312} y={692.448}>
                ROS
              </tspan>
            </text>
          </g>
          <g id="Report titles_29">
            <rect width={32} height={28} transform="translate(350 1068)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_29"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={350.312} y={1087.45}>
                ROS
              </tspan>
            </text>
          </g>
          <g id="Report titles_30">
            <rect width={79} height={28} transform="translate(55 182)" fill="white" />
            <text
              fontFamily="Gilroy W05 Medium"
              id="25-Hydroxy Vitamin D_30"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={55.2422} y={201.448}>
                Pathway A
              </tspan>
            </text>
          </g>
          <text
            fontFamily="Gilroy W05 Medium"
            id="Pathway B"
            fill="#818181"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontSize={16}
            letterSpacing="0em"
          >
            <tspan x={388.461} y={201.448}>
              Pathway B
            </tspan>
          </text>
          <text
            fontFamily="Gilroy W05 Medium"
            id="Pathway C"
            fill="#818181"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontSize={16}
            letterSpacing="0em"
          >
            <tspan x={687.469} y={201.448}>
              Pathway C
            </tspan>
          </text>
          <g id="gene-ADIPOQ" {...geneGroupProps("ADIPOQ", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M466 533C466 530.791 467.791 529 470 529H548C550.209 529 552 530.791 552 533V549C552 551.209 550.209 553 548 553H470C467.791 553 466 551.209 466 549V533Z"
                fill={adipoq.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-label_5"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={482.449} y={545.767}>
                  ADIPOQ
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="adipoq"
              groupId="gene-snps"
              genePalette={adipoq}
              startX={474}
              startY={555}
              snpCount={getGeneSnpCount("ADIPOQ", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-NFE2L2" {...geneGroupProps("NFE2L2", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M460 769C460 766.791 461.791 765 464 765H556C558.209 765 560 766.791 560 769V797C560 799.209 558.209 801 556 801H464C461.791 801 460 799.209 460 797V769Z"
                fill={nfe2l2.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-lozenge-label"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={483.867} y={788.448}>
                  NFE2L2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="nfe2l2"
              groupId="gene-snps_2"
              genePalette={nfe2l2}
              startX={468}
              startY={803}
              snpCount={getGeneSnpCount("NFE2L2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-UCP2" {...geneGroupProps("UCP2", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M287 881C287 878.791 288.791 877 291 877H363C365.209 877 367 878.791 367 881V897C367 899.209 365.209 901 363 901H291C288.791 901 287 899.209 287 897V881Z"
                fill={ucp2.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-label_6"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={309.486} y={893.767}>
                  UCP2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ucp2"
              groupId="gene-snps_3"
              genePalette={ucp2}
              startX={295}
              startY={903}
              snpCount={getGeneSnpCount("UCP2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SOD2" {...geneGroupProps("SOD2", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M414 881C414 878.791 415.791 877 418 877H490C492.209 877 494 878.791 494 881V897C494 899.209 492.209 901 490 901H418C415.791 901 414 899.209 414 897V881Z"
                fill={sod2.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-label_7"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={435.81} y={893.767}>
                  SOD2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="sod2"
              groupId="gene-snps_4"
              genePalette={sod2}
              startX={422}
              startY={903}
              snpCount={getGeneSnpCount("SOD2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CAT" {...geneGroupProps("CAT", onGeneClick)}>
            <g id="gene-lozenge_9">
              <path
                d="M528 880C528 877.791 529.791 876 532 876H604C606.209 876 608 877.791 608 880V896C608 898.209 606.209 900 604 900H532C529.791 900 528 898.209 528 896V880Z"
                fill={cat.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-label_8"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={554.978} y={892.767}>
                  CAT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cat"
              groupId="gene-snps_5"
              genePalette={cat}
              startX={536}
              startY={902}
              snpCount={getGeneSnpCount("CAT", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-TNF" {...geneGroupProps("TNF", onGeneClick)}>
            <g id="gene-lozenge_10">
              <path
                d="M596 1038C596 1035.79 597.791 1034 600 1034H672C674.209 1034 676 1035.79 676 1038V1054C676 1056.21 674.209 1058 672 1058H600C597.791 1058 596 1056.21 596 1054V1038Z"
                fill={tnf.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-label_9"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={623.866} y={1050.77}>
                  TNF
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="tnf"
              groupId="gene-snps_6"
              genePalette={tnf}
              startX={604}
              startY={1060}
              snpCount={getGeneSnpCount("TNF", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-IL6" {...geneGroupProps("IL6", onGeneClick)}>
            <g id="gene-lozenge_11">
              <path
                d="M596 1160C596 1157.79 597.791 1156 600 1156H672C674.209 1156 676 1157.79 676 1160V1176C676 1178.21 674.209 1180 672 1180H600C597.791 1180 596 1178.21 596 1176V1160Z"
                fill={il6.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-label_10"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={627.168} y={1172.77}>
                  IL6
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="il6"
              groupId="gene-snps_7"
              genePalette={il6}
              startX={604}
              startY={1182}
              snpCount={getGeneSnpCount("IL6", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-IRS1" {...geneGroupProps("IRS1", onGeneClick)}>
            <g id="gene-lozenge_12">
              <path
                d="M124 1273C124 1270.79 125.791 1269 128 1269H200C202.209 1269 204 1270.79 204 1273V1289C204 1291.21 202.209 1293 200 1293H128C125.791 1293 124 1291.21 124 1289V1273Z"
                fill={irs1.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-label_11"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={151.552} y={1285.77}>
                  IRS1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="irs1"
              groupId="gene-snps_8"
              genePalette={irs1}
              startX={132}
              startY={1295}
              snpCount={getGeneSnpCount("IRS1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SLC2A2" {...geneGroupProps("SLC2A2", onGeneClick)}>
            <g id="gene-lozenge_13">
              <path
                d="M119 1443C119 1440.79 120.791 1439 123 1439H196C198.209 1439 200 1440.79 200 1443V1459C200 1461.21 198.209 1463 196 1463H123C120.791 1463 119 1461.21 119 1459V1443Z"
                fill={slc2a2.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-label_12"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={135.417} y={1455.77}>
                  SLC2A2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="slc2a2"
              groupId="gene-snps_9"
              genePalette={slc2a2}
              startX={127}
              startY={1465}
              snpCount={getGeneSnpCount("SLC2A2", expectedSnps, geneColors)}
            />
          </g>
          <g id="Frame 466">
            <path
              d="M228.044 1371V1371.7H230C230.449 1371.7 230.875 1371.79 231.263 1371.95L231.53 1371.3C232.508 1371.71 233.29 1372.49 233.695 1373.47L233.05 1373.74C233.211 1374.13 233.3 1374.55 233.3 1375V1377H234V1381H233.3V1385H234V1389H233.3V1393H234V1397H233.3V1399C233.3 1399.45 233.211 1399.87 233.05 1400.26L233.695 1400.53C233.29 1401.51 232.508 1402.29 231.53 1402.7L231.263 1402.05C230.875 1402.21 230.449 1402.3 230 1402.3H228.044V1403H224.133V1402.3H220.221V1403H216.309V1402.3H212.397V1403H208.485V1402.3H204.573V1403H200.662V1402.3H196.75V1403H192.838V1402.3H188.927V1403H185.015V1402.3H181.103V1403H177.191V1402.3H173.279V1403H169.367V1402.3H165.456V1403H161.544V1402.3H157.633V1403H153.721V1402.3H149.809V1403H145.897V1402.3H141.985V1403H138.073V1402.3H134.162V1403H130.25V1402.3H126.338V1403H122.427V1402.3H118.515V1403H114.603V1402.3H110.691V1403H106.779V1402.3H102.867V1403H98.9561V1402.3H97C96.5514 1402.3 96.1254 1402.21 95.7373 1402.05L95.4688 1402.7C94.491 1402.29 93.709 1401.51 93.3037 1400.53L93.9502 1400.26C93.8094 1399.92 93.7233 1399.55 93.7041 1399.17L93.7002 1399V1397H93V1393H93.7002V1389H93V1385H93.7002V1381H93V1377H93.7002V1375C93.7002 1374.55 93.7893 1374.13 93.9502 1373.74L93.3037 1373.47C93.7092 1372.49 94.4911 1371.71 95.4688 1371.3L95.7373 1371.95C96.1254 1371.79 96.5514 1371.7 97 1371.7H98.9561V1371H102.867V1371.7H106.779V1371H110.691V1371.7H114.603V1371H118.515V1371.7H122.427V1371H126.338V1371.7H130.25V1371H134.162V1371.7H138.073V1371H141.985V1371.7H145.897V1371H149.809V1371.7H153.721V1371H157.633V1371.7H161.544V1371H165.456V1371.7H169.367V1371H173.279V1371.7H177.191V1371H181.103V1371.7H185.015V1371H188.927V1371.7H192.838V1371H196.75V1371.7H200.662V1371H204.573V1371.7H208.485V1371H212.397V1371.7H216.309V1371H220.221V1371.7H224.133V1371H228.044Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block_4">
              <text
                fontFamily="Gilroy W05 Medium"
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={109.441} y={1391.77}>
                  Insulin resistance
                </tspan>
              </text>
            </g>
          </g>
          <g id="gene-CRP" {...geneGroupProps("CRP", onGeneClick)}>
            <g id="gene-lozenge_14">
              <path
                d="M595 1273C595 1270.79 596.791 1269 599 1269H671C673.209 1269 675 1270.79 675 1273V1289C675 1291.21 673.209 1293 671 1293H599C596.791 1293 595 1291.21 595 1289V1273Z"
                fill={crp.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-label_13"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={621.438} y={1285.77}>
                  CRP
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="crp"
              groupId="gene-snps_10"
              genePalette={crp}
              startX={603}
              startY={1295}
              snpCount={getGeneSnpCount("CRP", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-GPX1" {...geneGroupProps("GPX1", onGeneClick)}>
            <g id="gene-lozenge_15">
              <path
                d="M645 879C645 876.791 646.791 875 649 875H721C723.209 875 725 876.791 725 879V895C725 897.209 723.209 899 721 899H649C646.791 899 645 897.209 645 895V879Z"
                fill={gpx1.lozengeFill}
              />
              <text
                fontFamily="Gilroy W05 Medium"
                id="gene-label_14"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={668.949} y={891.767}>
                  GPX1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="gpx1"
              groupId="gene-snps_11"
              genePalette={gpx1}
              startX={653}
              startY={901}
              snpCount={getGeneSnpCount("GPX1", expectedSnps, geneColors)}
            />
          </g>
          <path id="Vector 436" d="M326 839H685" stroke="black" strokeWidth={1.4} />
          <path id="Vector 437" d="M365 1000H636" stroke="black" strokeWidth={1.4} />
          <path
            id="Vector 438"
            d="M747 892V957.423H503.5M260 892V957.423H503.5M503.5 957.423V1000"
            stroke="black"
            strokeWidth={1.4}
          />
          <path
            id="Vector 439"
            d="M372.5 720V719.3H372.225L372.024 719.487L372.5 720ZM165.5 912L165.024 911.487L164.8 911.695V912H165.5ZM165.5 1264L169.541 1257H161.459L165.5 1264ZM415.5 720V719.3H372.5V720V720.7H415.5V720ZM372.5 720L372.024 719.487L165.024 911.487L165.5 912L165.976 912.513L372.976 720.513L372.5 720ZM165.5 912H164.8V1114.5H165.5H166.2V912H165.5ZM575 1114.5V1113.8H165.5V1114.5V1115.2H575V1114.5ZM165.5 1114.5H164.8V1229H165.5H166.2V1114.5H165.5ZM165.5 1229H164.8V1257.7H165.5H166.2V1229H165.5ZM575 1229V1228.3H165.5V1229V1229.7H575V1229Z"
            fill="#E44C4B"
          />
          <path
            id="Vector 440"
            d="M355.745 707V706.3H355.459L355.255 706.501L355.745 707ZM149 910L148.51 909.501L148.3 909.706V910H149ZM149 977H148.3V977.7H149V977ZM692 977H692.7V976.3H692V977ZM692 989L696.041 982H687.959L692 989ZM399.543 707V706.3H355.745V707V707.7H399.543V707ZM355.745 707L355.255 706.501L148.51 909.501L149 910L149.49 910.499L356.235 707.499L355.745 707ZM149 910H148.3V977H149H149.7V910H149ZM692 977H691.3V982.7H692H692.7V977H692ZM149 977V977.7H420.5V977V976.3H149V977ZM420.5 977V977.7H692V977V976.3H420.5V977Z"
            fill="#FFC647"
          />
          <path
            id="Vector 441"
            d="M791 903L790.511 903.501L791 903ZM603 725L605.395 732.72L610.883 726.785L603 725ZM606.085 727.854L605.609 728.367C606.275 728.984 606.956 729.615 607.652 730.26L608.128 729.746L608.604 729.233C607.908 728.588 607.226 727.957 606.56 727.34L606.085 727.854ZM610.227 731.692L609.751 732.205C610.415 732.821 611.092 733.449 611.78 734.087L612.256 733.574L612.733 733.061C612.044 732.422 611.367 731.795 610.703 731.178L610.227 731.692ZM614.35 735.517L613.874 736.03C614.541 736.65 615.219 737.279 615.906 737.918L616.383 737.405L616.859 736.892C616.172 736.254 615.494 735.624 614.826 735.004L614.35 735.517ZM618.475 739.349L617.998 739.862C618.667 740.484 619.345 741.114 620.031 741.752L620.507 741.239L620.984 740.726C620.298 740.088 619.621 739.458 618.952 738.837L618.475 739.349ZM622.587 743.173L622.11 743.686C622.784 744.313 623.466 744.948 624.155 745.59L624.632 745.077L625.109 744.565C624.42 743.923 623.738 743.288 623.064 742.661L622.587 743.173ZM626.697 747L626.22 747.512C626.901 748.146 627.588 748.787 628.283 749.434L628.76 748.922L629.237 748.41C628.543 747.763 627.855 747.122 627.174 746.487L626.697 747ZM630.809 750.832L630.332 751.344C631.02 751.986 631.715 752.633 632.415 753.286L632.892 752.775L633.37 752.263C632.669 751.609 631.975 750.962 631.286 750.32L630.809 750.832ZM634.926 754.672L634.449 755.184C635.132 755.821 635.821 756.464 636.514 757.112L636.992 756.6L637.47 756.088C636.776 755.441 636.087 754.798 635.404 754.16L634.926 754.672ZM639.051 758.522L638.573 759.034C639.251 759.667 639.933 760.305 640.62 760.947L641.098 760.435L641.576 759.924C640.889 759.282 640.206 758.644 639.528 758.011L639.051 758.522ZM643.173 762.374L642.695 762.886C643.371 763.518 644.051 764.154 644.736 764.794L645.214 764.282L645.692 763.771C645.008 763.131 644.327 762.495 643.651 761.863L643.173 762.374ZM647.269 766.205L646.791 766.716C647.477 767.358 648.167 768.004 648.861 768.653L649.339 768.142L649.818 767.631C649.124 766.981 648.434 766.336 647.748 765.694L647.269 766.205ZM651.378 770.05L650.899 770.561C651.582 771.201 652.269 771.844 652.959 772.49L653.437 771.979L653.916 771.468C653.226 770.822 652.539 770.179 651.856 769.539L651.378 770.05ZM655.498 773.909L655.019 774.42C655.697 775.055 656.377 775.693 657.061 776.334L657.54 775.823L658.019 775.313C657.335 774.672 656.654 774.033 655.976 773.398L655.498 773.909ZM659.6 777.755L659.121 778.266C659.803 778.906 660.488 779.548 661.176 780.193L661.655 779.683L662.134 779.172C661.446 778.527 660.761 777.884 660.079 777.245L659.6 777.755ZM663.699 781.601L663.22 782.111C663.904 782.753 664.59 783.398 665.279 784.045L665.758 783.534L666.238 783.024C665.549 782.377 664.862 781.732 664.178 781.09L663.699 781.601ZM667.81 785.461L667.331 785.972C668.01 786.61 668.691 787.25 669.375 787.892L669.854 787.382L670.334 786.872C669.65 786.229 668.969 785.589 668.29 784.951L667.81 785.461ZM671.912 789.316L671.433 789.826C672.114 790.467 672.798 791.11 673.484 791.755L673.963 791.245L674.443 790.735C673.757 790.09 673.073 789.447 672.392 788.806L671.912 789.316ZM676.007 793.167L675.527 793.677C676.21 794.32 676.895 794.964 677.582 795.611L678.061 795.101L678.541 794.591C677.854 793.945 677.169 793.3 676.486 792.657L676.007 793.167ZM680.113 797.033L679.633 797.542C680.312 798.182 680.993 798.823 681.675 799.466L682.155 798.956L682.635 798.447C681.953 797.804 681.272 797.162 680.593 796.523L680.113 797.033ZM684.207 800.89L683.727 801.399C684.409 802.042 685.094 802.687 685.779 803.334L686.259 802.825L686.74 802.315C686.054 801.669 685.37 801.024 684.687 800.38L684.207 800.89ZM688.3 804.749L687.82 805.258C688.501 805.901 689.184 806.546 689.868 807.191L690.349 806.682L690.829 806.173C690.145 805.527 689.462 804.883 688.78 804.24L688.3 804.749ZM692.402 808.621L691.922 809.13C692.6 809.77 693.28 810.412 693.961 811.055L694.441 810.546L694.922 810.037C694.241 809.394 693.561 808.752 692.883 808.112L692.402 808.621ZM696.487 812.479L696.007 812.988C696.69 813.633 697.374 814.28 698.059 814.928L698.54 814.419L699.021 813.91C698.335 813.263 697.651 812.616 696.968 811.97L696.487 812.479ZM700.579 816.348L700.098 816.856C700.778 817.5 701.459 818.144 702.141 818.789L702.622 818.281L703.104 817.772C702.422 817.127 701.74 816.482 701.06 815.839L700.579 816.348ZM704.671 820.22L704.19 820.728C704.869 821.372 705.55 822.016 706.231 822.662L706.713 822.153L707.194 821.645C706.513 821 705.832 820.355 705.152 819.711L704.671 820.22ZM708.754 824.087L708.272 824.595C708.953 825.24 709.635 825.886 710.317 826.533L710.799 826.025L711.28 825.517C710.598 824.87 709.916 824.224 709.235 823.579L708.754 824.087ZM712.842 827.963L712.361 828.471C713.04 829.115 713.719 829.76 714.4 830.406L714.882 829.898L715.363 829.39C714.683 828.745 714.003 828.1 713.324 827.455L712.842 827.963ZM716.924 831.836L716.442 832.344C717.122 832.99 717.803 833.637 718.485 834.284L718.967 833.777L719.449 833.269C718.767 832.622 718.086 831.975 717.406 831.329L716.924 831.836ZM721.005 835.714L720.523 836.221C721.202 836.867 721.882 837.513 722.562 838.16L723.045 837.653L723.527 837.145C722.847 836.499 722.167 835.852 721.487 835.206L721.005 835.714ZM725.085 839.594L724.603 840.101C725.282 840.747 725.961 841.394 726.641 842.041L727.124 841.534L727.606 841.027C726.927 840.38 726.247 839.733 725.568 839.087L725.085 839.594ZM729.161 843.474L728.679 843.981C729.358 844.628 730.037 845.276 730.716 845.923L731.199 845.416L731.682 844.909C731.003 844.262 730.324 843.615 729.644 842.968L729.161 843.474ZM733.237 847.359L732.754 847.865C733.433 848.513 734.112 849.16 734.79 849.808L735.274 849.301L735.757 848.795C735.078 848.147 734.399 847.5 733.72 846.852L733.237 847.359ZM737.309 851.244L736.826 851.751C737.505 852.399 738.183 853.046 738.861 853.694L739.344 853.188L739.828 852.682C739.15 852.034 738.471 851.386 737.793 850.738L737.309 851.244ZM741.381 855.134L740.897 855.64C741.575 856.288 742.253 856.936 742.931 857.584L743.415 857.079L743.899 856.573C743.221 855.925 742.543 855.276 741.864 854.628L741.381 855.134ZM745.446 859.022L744.962 859.528C745.641 860.178 746.32 860.827 746.998 861.477L747.482 860.971L747.966 860.466C747.288 859.816 746.609 859.166 745.93 858.517L745.446 859.022ZM749.515 862.919L749.03 863.424C749.707 864.073 750.384 864.721 751.059 865.369L751.544 864.864L752.028 864.359C751.353 863.711 750.676 863.062 749.999 862.413L749.515 862.919ZM753.576 866.814L753.092 867.319C753.77 867.97 754.447 868.62 755.124 869.27L755.609 868.765L756.094 868.26C755.417 867.61 754.739 866.96 754.061 866.309L753.576 866.814ZM757.636 870.713L757.151 871.217C757.828 871.868 758.504 872.518 759.179 873.167L759.664 872.662L760.149 872.158C759.474 871.508 758.798 870.858 758.121 870.208L757.636 870.713ZM761.696 874.617L761.211 875.122C761.887 875.773 762.563 876.423 763.237 877.072L763.722 876.568L764.208 876.064C763.534 875.414 762.858 874.764 762.182 874.113L761.696 874.617ZM765.744 878.516L765.258 879.02C765.937 879.674 766.614 880.328 767.291 880.98L767.777 880.476L768.263 879.973C767.586 879.32 766.909 878.667 766.23 878.012L765.744 878.516ZM769.802 882.431L769.315 882.934C769.989 883.585 770.661 884.234 771.332 884.883L771.819 884.379L772.305 883.876C771.634 883.228 770.962 882.578 770.288 881.927L769.802 882.431ZM773.849 886.342L773.362 886.846C774.039 887.5 774.713 888.152 775.386 888.804L775.873 888.301L776.36 887.798C775.687 887.146 775.012 886.493 774.336 885.839L773.849 886.342ZM777.888 890.253L777.401 890.755C778.078 891.411 778.753 892.066 779.426 892.719L779.913 892.216L780.401 891.714C779.727 891.06 779.052 890.406 778.375 889.75L777.888 890.253ZM781.937 894.18L781.449 894.682C782.122 895.335 782.792 895.986 783.461 896.636L783.949 896.134L784.437 895.632C783.768 894.982 783.097 894.33 782.424 893.677L781.937 894.18ZM785.969 898.099L785.481 898.6C786.157 899.258 786.831 899.914 787.503 900.568L787.991 900.067L788.479 899.565C787.807 898.911 787.133 898.255 786.457 897.597L785.969 898.099ZM790 902.025L789.512 902.526C789.845 902.852 790.179 903.177 790.511 903.501L791 903L791.489 902.499C791.156 902.174 790.823 901.849 790.489 901.524L790 902.025ZM791 903L790.511 903.501C790.862 903.843 791.208 904.185 791.55 904.525L792.044 904.029L792.538 903.533C792.193 903.189 791.843 902.845 791.489 902.499L791 903ZM794.053 906.07L793.549 906.556C794.197 907.229 794.828 907.898 795.442 908.564L795.956 908.089L796.471 907.615C795.85 906.942 795.212 906.265 794.557 905.585L794.053 906.07ZM797.856 910.2L797.33 910.662C797.963 911.383 798.576 912.099 799.168 912.811L799.706 912.363L800.244 911.915C799.643 911.193 799.023 910.468 798.382 909.738L797.856 910.2ZM801.436 914.499L800.886 914.932C801.488 915.698 802.068 916.459 802.624 917.214L803.187 916.799L803.751 916.384C803.186 915.617 802.598 914.844 801.986 914.066L801.436 914.499ZM804.809 919.08L804.232 919.476C804.77 920.261 805.284 921.04 805.773 921.814L806.364 921.439L806.956 921.065C806.458 920.277 805.935 919.483 805.387 918.684L804.809 919.08ZM807.829 923.864L807.223 924.213C807.692 925.029 808.135 925.838 808.55 926.64L809.172 926.318L809.793 925.996C809.368 925.175 808.916 924.348 808.436 923.515L807.829 923.864ZM810.419 928.877L809.782 929.168C810.172 930.022 810.531 930.868 810.861 931.707L811.512 931.451L812.164 931.195C811.825 930.333 811.456 929.463 811.056 928.586L810.419 928.877ZM812.472 934.124L811.807 934.341C812.098 935.236 812.354 936.121 812.578 936.997L813.256 936.824L813.934 936.651C813.703 935.745 813.438 934.831 813.138 933.908L812.472 934.124ZM813.858 939.579L813.169 939.704C813.337 940.631 813.468 941.547 813.563 942.452L814.259 942.379L814.955 942.306C814.857 941.366 814.721 940.415 814.546 939.454L813.858 939.579ZM814.442 945.171L813.742 945.189C813.766 946.128 813.752 947.056 813.7 947.972L814.399 948.011L815.097 948.051C815.152 947.096 815.167 946.13 815.142 945.153L814.442 945.171ZM814.122 950.814L813.429 950.716C813.299 951.633 813.132 952.538 812.93 953.431L813.612 953.586L814.295 953.741C814.506 952.81 814.68 951.867 814.815 950.912L814.122 950.814ZM812.874 956.312L812.207 956.102C811.93 956.981 811.618 957.849 811.273 958.705L811.923 958.967L812.572 959.228C812.93 958.339 813.254 957.437 813.542 956.522L812.874 956.312ZM810.77 961.546L810.141 961.237C809.736 962.062 809.3 962.875 808.834 963.678L809.439 964.03L810.045 964.381C810.526 963.551 810.978 962.709 811.398 961.855L810.77 961.546ZM807.943 966.427L807.361 966.038C806.849 966.804 806.31 967.56 805.747 968.305L806.305 968.727L806.863 969.15C807.443 968.383 807.997 967.606 808.525 966.816L807.943 966.427ZM804.545 970.928L804.009 970.477C803.412 971.185 802.793 971.883 802.152 972.571L802.665 973.048L803.177 973.525C803.832 972.821 804.467 972.106 805.08 971.38L804.545 970.928ZM800.701 975.066L800.21 974.567C799.55 975.216 798.871 975.857 798.176 976.488L798.647 977.006L799.117 977.524C799.826 976.881 800.518 976.228 801.192 975.565L800.701 975.066ZM796.517 978.867L796.066 978.332C795.358 978.929 794.635 979.517 793.898 980.096L794.331 980.646L794.764 981.197C795.512 980.608 796.248 980.01 796.968 979.402L796.517 978.867ZM792.078 982.363L791.662 981.8C790.915 982.351 790.157 982.894 789.388 983.428L789.787 984.003L790.187 984.578C790.966 984.036 791.735 983.486 792.493 982.926L792.078 982.363ZM787.444 985.586L787.06 985.001C786.28 985.513 785.492 986.017 784.696 986.513L785.066 987.108L785.436 987.702C786.241 987.2 787.039 986.69 787.828 986.171L787.444 985.586ZM782.651 988.574L782.294 987.972C781.489 988.448 780.678 988.917 779.861 989.378L780.205 989.988L780.549 990.598C781.374 990.132 782.194 989.658 783.008 989.176L782.651 988.574ZM777.731 991.352L777.399 990.736C776.574 991.18 775.745 991.617 774.913 992.046L775.233 992.669L775.554 993.291C776.394 992.858 777.23 992.417 778.063 991.968L777.731 991.352ZM772.709 993.943L772.399 993.315C771.557 993.731 770.713 994.139 769.868 994.54L770.168 995.173L770.468 995.805C771.319 995.401 772.17 994.99 773.019 994.57L772.709 993.943ZM767.605 996.364L767.315 995.727C766.457 996.118 765.599 996.501 764.743 996.876L765.024 997.517L765.305 998.159C766.167 997.781 767.031 997.395 767.895 997.001L767.605 996.364ZM762.435 998.632L762.162 997.987C761.289 998.356 760.419 998.716 759.553 999.069L759.817 999.717L760.081 1000.37C760.952 1000.01 761.828 999.648 762.707 999.277L762.435 998.632ZM757.206 1000.76L756.95 1000.11C756.063 1000.46 755.183 1000.8 754.311 1001.13L754.559 1001.78L754.807 1002.44C755.684 1002.1 756.57 1001.76 757.462 1001.41L757.206 1000.76ZM751.911 1002.77L751.67 1002.11C750.781 1002.44 749.901 1002.75 749.034 1003.06L749.267 1003.72L749.501 1004.38C750.373 1004.07 751.257 1003.75 752.152 1003.43L751.911 1002.77ZM746.58 1004.66L746.354 1003.99C745.448 1004.3 744.558 1004.6 743.685 1004.89L743.905 1005.56L744.125 1006.22C745.002 1005.93 745.897 1005.63 746.807 1005.32L746.58 1004.66ZM741.246 1006.42L741.032 1005.76C740.102 1006.05 739.197 1006.34 738.32 1006.61L738.527 1007.28L738.734 1007.95C739.616 1007.68 740.525 1007.39 741.459 1007.09L741.246 1006.42ZM735.813 1008.11L735.612 1007.44C735.166 1007.57 734.729 1007.7 734.301 1007.83L734.5 1008.5L734.699 1009.17C735.128 1009.04 735.567 1008.91 736.015 1008.78L735.813 1008.11Z"
            fill="#818181"
          />
          <g id="Lipids_3">
            <g id="diamond_2">
              <path
                id="Vector 352_2"
                d="M300 727.325L324.501 703L349 727.325L336.75 750L324.5 750L312.25 750L300 727.325Z"
                fill="white"
                stroke="#1A1A1A"
              />
              <text
                fontFamily="Gilroy W05 Bold"
                id="label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={315.82} y={728.415}>
                  oxi-{" "}
                </tspan>
                <tspan x={316.602} y={738.415}>
                  LDL
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </>
  );
};

const SvgCardiometabolicInflammationDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1370}
    viewBox="0 170 1024 1370"
    fill="none"
    {...props}
  >
    <CardiometabolicInflammationDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18293_231788">
        <rect width={1024} height={1540} fill="white" />
      </clipPath>
      <clipPath id="clip1_18293_231788">
        <rect width={1024} height={1370} fill="white" transform="translate(0 170)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgCardiometabolicInflammationDiagram;
